import { render, staticRenderFns } from "./socials.vue?vue&type=template&id=f0b231f6&scoped=true&"
import script from "./socials.vue?vue&type=script&lang=js&"
export * from "./socials.vue?vue&type=script&lang=js&"
import style0 from "./socials.vue?vue&type=style&index=0&id=f0b231f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b231f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/ui/icon.vue').default})
